export default __webpack_public_path__ + "static/media/trylleby-property-22.3ac97ac1.jpg";